import { FlexBox } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';
import { FieldArray, getFormValues } from 'redux-form';

import { useAppSelector } from 'utils/redux/useAppSelector';

import { SetPreviewLanguageFn } from '../../../hooks/useMessengerPreview';
import { messengerAppearanceFormName } from '../../../messengerSettingsFormValueSelector';
import { FormValues, messengerSettingsFormFields } from '../../../types';
import { FormSectionTitle } from '../../formSectionTitle';

import {
  DynamicStringsEditor,
  LanguageSelector,
  LanguageSelectorProps,
} from './components';
import { MessengerTranslatedLanguage } from './languages';

interface LanguageSettingsProps {
  setPreviewLanguage: SetPreviewLanguageFn;
}

export function LanguageSettings({
  setPreviewLanguage,
}: LanguageSettingsProps): JSX.Element {
  const a = useAppSelector(
    getFormValues(messengerAppearanceFormName),
  ) as FormValues;
  const defaultLanguage = a?.defaultLanguage;
  const [currentSelectedLanguage, setCurrentSelectedLanguage] =
    useState<MessengerTranslatedLanguage>('en');

  useEffect(() => {
    setPreviewLanguage(currentSelectedLanguage);
  }, [setPreviewLanguage, currentSelectedLanguage]);

  return (
    <FlexBox flexDirection="column" gap="300">
      <FormSectionTitle title="Language and intro text" />
      <FlexBox gap="500">
        <FieldArray<LanguageSelectorProps, MessengerTranslatedLanguage>
          name={messengerSettingsFormFields.availableLocales}
          component={LanguageSelector}
          props={{
            defaultLanguageCode: defaultLanguage,
            selectedLanguage: currentSelectedLanguage,
            onSelectLanguage: setCurrentSelectedLanguage,
          }}
        />
        <DynamicStringsEditor currentLangCode={currentSelectedLanguage} />
      </FlexBox>
    </FlexBox>
  );
}
